import { Text } from '@mantine/core';

export default function CanNotStartTesting() {
  return (
    <div className="flex flex-col items-center justify-center px-6 pb-6">
      <Text
        className="text-center"
        size="xl"
        fw={500}
        mb="md"
      >
        Demo Workspace
      </Text>
      <Text className="text-center">
        This feature is not available in the demo workspace. Please contact the{' '}
        <a href="mailto:jinjing@stably.ai">
          <strong>Stably team</strong>
        </a>{' '}
        to enable this feature.
      </Text>
    </div>
  );
}
